import React from 'react';
export function Footer() {
  return <footer className="bg-brand-deep text-blue-200 py-8 px-4 text-center border-t border-white/10" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <h3 className="text-2xl font-black text-white mb-4" data-id="element-111">
          ❄️ PACK COMPLETO DE REFRIGERACIÓN
        </h3>
        <p className="mb-8 italic text-lg" data-id="element-112">
          El oficio que aprendés hoy es la libertad que tenés mañana.
        </p>

        <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-113">
          <p className="mb-4 font-medium" data-id="element-114">
            © 2025 GUÍA DIGITAL 360 — Todos los derechos reservados. 🇦🇷
          </p>
          <div className="flex justify-center gap-4" data-id="element-115">
            <a href="#" className="hover:text-white transition-colors" data-id="element-116">
              Privacidad
            </a>
            <span data-id="element-117">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-118">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}